import RelevoIcon from '../Icons/RelevoIcon';
import { AccessibilityOption } from './AccessibilityButton';

const RelevoLink = () => {
  return (
    <AccessibilityOption
      name={'Centro de relevo'}
      icon={<RelevoIcon className="p-1 text-white" />}
      onClick={() => window.open('https://centroderelevo.gov.co/', '_blank')}
    />
  );
};

export default RelevoLink;
